























import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileVideo, faVideo, faFilm } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue'

library.add(faFileVideo, faVideo, faFilm)

export default Vue.extend({
  name: 'HomePage',
  components: {
    FontAwesomeIcon,
  },
})
